export default defineNuxtRouteMiddleware((to, from) => {
  // These routes are handled by server API endpoints
  // This middleware prevents Vue Router warnings
  // No actual redirection is needed as the server will handle the requests
  return;
}); 